module.exports = __webpack_public_path__ + "img/boston-party.57b6d19f.jpeg";